import { useEffect, useState } from "react";
import { createMemoryRouter } from "react-router-dom";

import App from "@/booking/app";
import { BookingEvent, NavigationEventEnum } from "@/booking/eventEnums";
import { routes } from "@/booking/router";

import styles from "./BookingDrawer.module.css";

const BookingDrawer = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const [packageId, setPackageId] = useState(0);

  const close = () => {
    setClosing(true);
  };

  useEffect(() => {
    const eventHandler = (e: MessageEvent) => {
      const { eventType, event } = e.data ?? {};
      if (!eventType) {
        return;
      }

      if (eventType === NavigationEventEnum.ROOMS) {
        setIsFullScreen(true);
      }

      if (eventType === NavigationEventEnum.EXIT) {
        close();
      }

      if (eventType === BookingEvent.OPEN_DRAWER) {
        event?.packageId && setPackageId(Number(event?.packageId));
        setOpen(true);
      }
    };

    window.addEventListener("message", eventHandler);

    return () => {
      window.removeEventListener("message", eventHandler);
    };
  }, []);

  const router = createMemoryRouter(routes);
  const overlayAnimation = closing
    ? "animate-[fadeOut_0.3s_ease-out_forwards]"
    : "animate-[fadeIn_0.3s_ease-out_forwards]";
  const drawerAnimation = closing
    ? "animate-[slideOut_0.3s_ease-out_forwards]"
    : "animate-[slideIn_0.3s_ease-out_forwards]";

  return (
    <div
      id="booking-drawer"
      className={`${styles.drawer} ${open ? "block" : "hidden"}`}
    >
      <div
        className={`${styles.overlay} ${overlayAnimation}`}
        onClick={close}
      />
      <div
        id="booking-root"
        className={`${styles.drawerContent} ${drawerAnimation} ${isFullScreen ? "max-w-full" : ""}`}
        onAnimationEnd={() => {
          if (closing) {
            setOpen(false);
            setClosing(false);
            setIsFullScreen(false);
          }
        }}
      >
        {packageId && open ? (
          <App packageId={packageId} customRouter={router} />
        ) : (
          <div className="flex-1">❗Error...</div>
        )}
      </div>
    </div>
  );
};

export default BookingDrawer;
